<app-shared-loading *ngIf="loading"></app-shared-loading>
<div class="general-title">
    <h1 class="pl-1 title">{{ 'cash-Subtitle' | translation | async }}</h1>
</div>
<app-return-methods [itsMobileCtrl]="true" [unique]="this.transaction.ORDER_METHOD" (RT)="changeMethod()"></app-return-methods>
<div class="contentBox" *ngIf="!useEmebbedWallet && !loading">
    <div class="col-3">
        <div class="info-logo-container">
            <img src="{{ info.logo }}" class="payment_method_no_interactive red" alt="Logo de Bevalida" />
        </div>
    </div>
    <div class="col-7">
        <div class="methodInfo">
            <app-return-methods [itsMobileCtrl]="false" [unique]="this.transaction.ORDER_METHOD" (RT)="changeMethod()"></app-return-methods>
            <h1>{{ 'wallet-Title' | translation | async }}</h1>
            <div id="_bevalida_form" class="methodForm">
                <form [formGroup]="form" autocomplete="off">
                    <mat-form-field *ngIf="listCountries" appearance="outline">
                        <mat-label>{{ 'wallet-Country-Input' | translation | async }}</mat-label>
                        <mat-select formControlName="country" placeholder="{{ 'wallet-Country-Input' | translation | async }}">
                            <mat-option *ngFor="let country of listCountries" [value]="country.CODE">
                                {{ country.NAME }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline" [ngClass]="{ disabledInput: isControlReadOnly('email') }">
                        <mat-label>{{ 'forms-Email-Input' | translation | async }}</mat-label>
                        <input
                            type="email"
                            matInput
                            name="email"
                            placeholder="{{ 'forms-Email-Input' | translation | async }}"
                            maxlength="150"
                            formControlName="email"
                            required
                            [readonly]="isControlReadOnly('email')"
                        />
                    </mat-form-field>
                    <ng-container *ngFor="let validation of errorsMessages.email">
                        <div class="error-message" *ngIf="form.get('email').hasError(validation.type) && (form.get('email').dirty || form.get('email').touched)">
                            {{ validation.message }}
                        </div>
                    </ng-container>
                    <mat-form-field appearance="outline">
                        <mat-label>{{ 'wallet-Password-Input' | translation | async }}</mat-label>
                        <input type="password" matInput name="pass" placeholder="{{ 'wallet-Password-Input' | translation | async }}" maxlength="30" formControlName="pass" required />
                        <fa-icon matSuffix icon="lock"></fa-icon>
                    </mat-form-field>
                    <ng-container *ngFor="let validation of errorsMessages.pass">
                        <div class="error-message" *ngIf="form.get('pass').hasError(validation.type) && (form.get('pass').dirty || form.get('pass').touched)">
                            {{ validation.message }}
                        </div>
                    </ng-container>
                    <app-privacy-conditions (formPrivacyUpdate)="formPrivacyUpdate($event)"></app-privacy-conditions>
                </form>
                <div class="flexBox urlSection">
                    <a [href]="urlWalletSignUp" target="_blank" rel="noopener noreferrer">{{ urlWalletSignUpString }}</a>
                    <a [href]="urlWalletRecoverPass" target="_blank" rel="noopener noreferrer">{{ urlWalletRecoverPassString }}</a>
                </div>
            </div>
        </div>
        <app-buttons-bar [valid]="completedForms()" [template]="template" (PAY)="validData()"></app-buttons-bar>
    </div>
</div>
